import "./style.scss";
import * as React from "react";

// class Section extends React.Component
const Section = (props: SectionProps): any => {
  return (
    <div className={"section " + props.className}>
      <h3>{props.title}</h3>
      {props.children}
    </div>
  );
};

interface SectionProps {
  className?: string;
  title: string;
  children: any;
}

export default Section;



// WEBPACK FOOTER //
// ./client/modules/core/Section/index.tsx